import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
// suneditor関係
import suneditor from 'suneditor';
import plugins from 'suneditor/src/plugins';
import ja from 'suneditor/src/lang/ja';

// 使用するボタン
const BUTTON_LIST = [
    ['bold', 'underline', 'fontSize', 'fontColor', 'list'],
    ['removeFormat'],
    ['codeView']
];

/**
 * suneditorのコンポーネント
 * https://www.npmjs.com/package/suneditor
 */
export default {
    name: 'suneditor',
    template: '#suneditor_template',
    data() {
        return {
            // suneditorのオブジェクト
            editor: null,
            // suneditorのjQueryオブジェクト
            _editor: null,
            // HTMLのID
            id: null,
            // 編集中の値
            edit_value: '',
            // HTML編集中フラグ
            is_code_view: false,
        };
    },
    props: {
        // 表示モード
        mode: {
            type: String,
            default: 'classic',
            required: false,
        },
        // v-modelの値
        modelValue: {
            type: String,
        },
        // プレースホルダ
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
        // リンクボタンを表示するか
        use_link_edit: {
            type: Boolean,
            default: true,
            required: false,
        },
        // 必須
        required: {
            type: Boolean,
            default: false,
            required: false,
        },
        // 高さ
        height: {
            type: Number,
            default: 100,
            required: false,
        },
        preview_height: {
            type: Number,
            default: 120,
            required: false,
        },
    },
    computed: {
        // モーダル表示か否か
        isModalMode: function () {
            return (this.mode === 'modal');
        },
        // プレビュー用データ
        preview: function () {
            if (this.modelValue) {
                return this.modelValue;
            }
            return '<span class="text-black-50">' + this.placeholder + '</span>';
        }
    },
    mounted: function () {
        this.initialize();
    },
    watch: {
        // HTML編集フラグが立ったら編集エリアのデータ調整
        is_code_view: function (bool) {
            this.codeEditAdjustValue(bool);
        }
    },
    mixins: [
        commonMixin,
        modalMixin,
    ],
    emits: ['update:modelValue'],
    methods: {
        // 初期化
        initialize: async function () {
            // ID適用
            this.id = await this.createId();
            await this.$nextTick();
            // 初期化
            this.editor = suneditor.create(this.id, {
                mode: (this.mode === 'modal') ? 'classic' : this.mode,
                plugins: plugins,
                buttonList: BUTTON_LIST,
                lang: ja,
                defaultTag: 'pre',
                showPathLabel: false,
                height: this.height,
                defaultStyle: 'font-size: 14px;',
                strictMode: false, //【重要】suneditorのcleanHTML補正を緩める。これがないと空タグが削除される。
                //              placeholder: this.placeholder,
                //              value: this.modelValue,
            });
            this.editor.onload = () => {
                // 初回編集データに代入
                this.edit_value = this.adjustValue(this.modelValue);
                // adjustValue()を通す為、create時にvalueで指定ではなくsetContents()でセットする
                this.editor.setContents(this.edit_value);
                // UI調整
                this.adjustUI();
            };
            this.editor.onChange = (value) => {
                this.edit_value = this.adjustValue(value);
                // &ZeroWidthSpace;という空文字コードが入ってしまうのでsetContentsでクリアする  
                if (!this.edit_value.length) {
                    this.editor.setContents('');
                }
            };
            this.editor.onBlur = () => { 
                if (!this.isModalMode) {
                    this.emitUpdatValue();
                }
            };
            this.editor.toggleCodeView = (isCodeView) => {
                this.is_code_view = isCodeView;
            };
            // suneditorのjqueryオブジェクトをセット
            this._editor = $('[data-id="' + this.id + '"] .sun-editor');
        },
        // 更新
        update: function (event) {
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            this.emitUpdatValue();
            this.close();
        },
        // キャンセル
        cancel: function () {
            this.close();
            // valueの値で編集エリアを元に戻す
            this.editor.setContents(this.adjustValue(this.modelValue));
        },
        // idを生成
        createId: async function () {
            await this.$_sleep(1);
            return 'suneditor' + moment().unix() + Math.random();
        },
        // 入力内容調整
        adjustValue: function (val) {
            // 空コード削除
            val = val.replace(/\u200B/g,'');
            // 自動挿入されるpreタグを除去
            val = val.replace(/(<\/|<)(pre)(>\n|>)/g, '');
            // strongタグをbタグへ変換。textTagsで定義するとクリアできなくなる
            val = val.replace(/(<\/|<)(strong)/g, '$1b');
            // <br>と閉じタグ前後の改行を除去
            val = val.replace(/(<br>|<\/[a-z1-6]*?>)(\n*)/g, '$1\n');
            val = val.replace(/(\n)(<br>|<\/[a-z1-6]*?>)/g, '$2');
            // タグ先頭のインデント除去
            val = val.replace(/(\n)( {2})(<[a-z])/g, '$1$3');
            // 空HTMLの場合は除去されてしまうため、半角スペースを入れる
            val = val.replace(/(>)(<\/[a-z1-6]*?>)/g, '$1 $2');
            // 末尾<br>は削除
            val = val.replace(/(<br>)*\n*$/, '');
            return val;
        },
        // HTML直接編集の内容調整
        codeEditAdjustValue: function (show) {
            const $target = this._editor.find('.se-wrapper-code');
            let value = $target.val();
            value = this.adjustValue(value);
            this.edit_value = value;
            // 編集開始時は編集textareaに戻す
            if (show) {
                $target.val(value);
            // 編集終了時はsuneditorへ値をセット
            } else {
                this.editor.setContents(value);
            }
        },
        // UI調整(CSSで困難な為jQueryで行う)
        adjustUI: function () {
            // ダウンロードリンクを非表示
            this._editor.find('label:has(._se_anchor_download)').hide();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function () {
            this.$emit('update:modelValue', this.edit_value);
        }
    }
};
